import * as c from './constants';
import { initAction, successAction, errorAction } from 'helpers/actionsFormat';

export const fetchFeedbackInsightsOverviewAction = payload =>
  initAction(c.FETCH_FEEDBACK_INSIGHTS_OVERVIEW, payload);
export const feedbackInsightsOverviewLoadedAction = payload =>
  successAction(c.FEEDBACK_INSIGHTS_OVERVIEW_LOADED, payload);
export const feedbackInsightsOverviewFailedAction = error =>
  errorAction(c.FEEDBACK_INSIGHTS_OVERVIEW_FAILED, error);

export const fetchFeedbackInsightsRatingTrendAction = payload =>
  initAction(c.FETCH_FEEDBACK_INSIGHTS_RATING_TREND, payload);
export const feedbackInsightsRatingTrendLoadedAction = payload =>
  successAction(c.FEEDBACK_INSIGHTS_RATING_TREND_LOADED, payload);
export const feedbackInsightsRatingTrendFailedAction = error =>
  errorAction(c.FEEDBACK_INSIGHTS_RATING_TREND_FAILED, error);

export const fetchFeedbackInsightsServicePeriodAction = payload =>
  initAction(c.FETCH_FEEDBACK_INSIGHTS_SERVICE_PERIOD, payload);
export const feedbackInsightsServicePeriodLoadedAction = payload =>
  successAction(c.FEEDBACK_INSIGHTS_SERVICE_PERIOD_LOADED, payload);
export const feedbackInsightsServicePeriodFailedAction = error =>
  errorAction(c.FEEDBACK_INSIGHTS_SERVICE_PERIOD_FAILED, error);

export const fetchFeedbackInsightsOutletComparisonAction = payload =>
  initAction(c.FETCH_FEEDBACK_INSIGHTS_OUTLET_COMPARISON, payload);
export const feedbackInsightsOutletComparisonLoadedAction = payload =>
  successAction(c.FEEDBACK_INSIGHTS_OUTLET_COMPARISON_LOADED, payload);
export const feedbackInsightsOutletComparisonFailedAction = error =>
  errorAction(c.FEEDBACK_INSIGHTS_OUTLET_COMPARISON_FAILED, error);
